var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import axios from 'axios';
import i18n from 'i18next';
import { substituteParams, useAPI } from '../../../state';
var LOCATION_HOURS_BATCH_API = '/api/orgConfig/locations/hours/batch';
var HQ_TIME_ZONE_API = '/api/orgConfig/hqTimeZone';
var COPY_HOURS_FROM_API = '/api/orgConfig/locations/{locationId}/hours/copyFrom';
var HOLIDAYS_REGIONS_API = '/api/orgConfig/holidays/regions/{countryCode}';
var HOLIDAYS_REGION_API = '/api/orgConfig/holidays/region/{countryCode}/{regionCode}';
var HOLIDAYS_COUNTRY_API = '/api/orgConfig/holidays/region/{countryCode}';
/** Extracts the "MM-DD" portion of a "YYYY-MM-DD" date, used to order/group holidays
 *  by calendar position independent of year. */
export var monthDayOf = function (date) {
  return date.slice(5, 10);
};
/** Collapses holidays that share a name (e.g. the same statutory holiday returned for
 *  multiple years, or a moving holiday like Good Friday) into a single group, sorted by
 *  calendar month-day so they read Jan → Dec. */
export function groupHolidaysByName(holidays) {
  var groups = new Map();
  for (var _i = 0, holidays_1 = holidays; _i < holidays_1.length; _i++) {
    var h = holidays_1[_i];
    var existing = groups.get(h.name);
    if (existing) {
      existing.dates.push(h.date);
      if (h.date < existing.displayDate) existing.displayDate = h.date;
    } else {
      groups.set(h.name, {
        key: h.name,
        name: h.name,
        displayDate: h.date,
        dates: [h.date]
      });
    }
  }
  return Array.from(groups.values()).sort(function (a, b) {
    return monthDayOf(a.displayDate).localeCompare(monthDayOf(b.displayDate));
  });
}
export var useHqTimeZoneAPI = function (configVersionId) {
  return useAPI("".concat(HQ_TIME_ZONE_API, "?configVersionId={configVersionId}"), {
    configVersionId: configVersionId !== null && configVersionId !== void 0 ? configVersionId : 0
  }, 'GET', {
    key: "hqTimeZone-".concat(configVersionId !== null && configVersionId !== void 0 ? configVersionId : 'none')
  });
};
export function saveHqTimeZone(configVersionId, hqTimeZone) {
  return __awaiter(this, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          url = configVersionId ? "".concat(HQ_TIME_ZONE_API, "?configVersionId=").concat(configVersionId) : HQ_TIME_ZONE_API;
          return [4 /*yield*/, axios.put(url, {
            hqTimeZone: hqTimeZone
          }, {
            withCredentials: true
          })];
        case 1:
          _a.sent();
          return [2 /*return*/];
      }
    });
  });
}
export var useLocationHoursBatchAPI = function (configVersionId) {
  return useAPI("".concat(LOCATION_HOURS_BATCH_API, "?configVersionId={configVersionId}"), {
    configVersionId: configVersionId !== null && configVersionId !== void 0 ? configVersionId : 0
  }, 'GET', {
    key: "locationHoursBatch-".concat(configVersionId !== null && configVersionId !== void 0 ? configVersionId : 'none')
  });
};
export var useSaveLocationHoursBatchAPI = function () {
  return useAPI(LOCATION_HOURS_BATCH_API, {}, 'POST', {
    key: 'saveLocationHoursBatch'
  });
};
export var useCopyHoursFromAPI = function (locationId) {
  return useAPI(substituteParams(COPY_HOURS_FROM_API, {
    locationId: locationId
  }), {
    locationId: locationId
  }, 'POST', {
    key: "copyHoursFrom-".concat(locationId)
  });
};
export var useHolidayRegionsAPI = function (countryCode) {
  var _a;
  if (countryCode === void 0) {
    countryCode = 'US';
  }
  var lang = (_a = i18n.language) !== null && _a !== void 0 ? _a : 'en';
  var url = "".concat(substituteParams(HOLIDAYS_REGIONS_API, {
    countryCode: countryCode
  }), "?lang=").concat(encodeURIComponent(lang));
  return useAPI(url, {
    countryCode: countryCode
  }, 'GET', {
    key: "holidayRegions-".concat(countryCode, "-").concat(lang)
  });
};
export var useRegionHolidaysAPI = function (countryCode, regionCode) {
  var _a;
  var cc = countryCode || 'US';
  var lang = (_a = i18n.language) !== null && _a !== void 0 ? _a : 'en';
  var baseUrl = regionCode ? substituteParams(HOLIDAYS_REGION_API, {
    countryCode: cc,
    regionCode: regionCode
  }) : substituteParams(HOLIDAYS_COUNTRY_API, {
    countryCode: cc
  });
  var url = "".concat(baseUrl, "?lang=").concat(encodeURIComponent(lang));
  return useAPI(url, {
    countryCode: cc,
    regionCode: regionCode || ''
  }, 'GET', {
    key: "regionHolidays-".concat(countryCode, "-").concat(regionCode, "-").concat(lang)
  });
};
export var TIMEZONE_OPTIONS = [{
  label: 'UTC',
  offset: 0,
  iana: 'Etc/UTC'
}, {
  label: 'International Date Line West',
  offset: -12,
  iana: 'Etc/GMT+12'
}, {
  label: 'Midway Island, Samoa',
  offset: -11,
  iana: 'Pacific/Pago_Pago'
}, {
  label: 'Hawaii',
  offset: -10,
  iana: 'Pacific/Honolulu'
}, {
  label: 'Alaska',
  offset: -9,
  iana: 'America/Anchorage'
}, {
  label: 'Pacific Time — US & Canada',
  offset: -8,
  iana: 'America/Los_Angeles'
}, {
  label: 'Pacific Time — Canada (Vancouver)',
  offset: -8,
  iana: 'America/Vancouver'
}, {
  label: 'Arizona',
  offset: -7,
  iana: 'America/Phoenix'
}, {
  label: 'Mountain Time — US & Canada',
  offset: -7,
  iana: 'America/Denver'
}, {
  label: 'Mountain Time — Canada (Edmonton)',
  offset: -7,
  iana: 'America/Edmonton'
}, {
  label: 'Central Time — US & Canada',
  offset: -6,
  iana: 'America/Chicago'
}, {
  label: 'Central Time — Canada (Winnipeg)',
  offset: -6,
  iana: 'America/Winnipeg'
}, {
  label: 'Mexico City',
  offset: -6,
  iana: 'America/Mexico_City'
}, {
  label: 'Central America (Guatemala)',
  offset: -6,
  iana: 'America/Guatemala'
}, {
  label: 'Eastern Time — US & Canada',
  offset: -5,
  iana: 'America/New_York'
}, {
  label: 'Eastern Time — Canada (Toronto)',
  offset: -5,
  iana: 'America/Toronto'
}, {
  label: 'Indiana (East)',
  offset: -5,
  iana: 'America/Indiana/Indianapolis'
}, {
  label: 'Bogota, Lima, Quito',
  offset: -5,
  iana: 'America/Bogota'
}, {
  label: 'Lima',
  offset: -5,
  iana: 'America/Lima'
}, {
  label: 'Jamaica',
  offset: -5,
  iana: 'America/Jamaica'
}, {
  label: 'Atlantic Time — Canada',
  offset: -4,
  iana: 'America/Halifax'
}, {
  label: 'Caracas, La Paz',
  offset: -4,
  iana: 'America/Caracas'
}, {
  label: 'Santiago',
  offset: -4,
  iana: 'America/Santiago'
}, {
  label: 'Santo Domingo',
  offset: -4,
  iana: 'America/Santo_Domingo'
}, {
  label: 'Brasilia',
  offset: -3,
  iana: 'America/Sao_Paulo'
}, {
  label: 'Buenos Aires, Georgetown',
  offset: -3,
  iana: 'America/Argentina/Buenos_Aires'
}, {
  label: 'Greenland',
  offset: -3,
  iana: 'America/Nuuk'
}, {
  label: 'Mid-Atlantic',
  offset: -2,
  iana: 'Atlantic/South_Georgia'
}, {
  label: 'Azores',
  offset: -1,
  iana: 'Atlantic/Azores'
}, {
  label: 'Cape Verde Is.',
  offset: -1,
  iana: 'Atlantic/Cape_Verde'
}, {
  label: 'Dublin, Edinburgh, Lisbon, London',
  offset: 0,
  iana: 'Europe/London'
}, {
  label: 'Casablanca, Monrovia',
  offset: 0,
  iana: 'Africa/Casablanca'
}, {
  label: 'Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
  offset: 1,
  iana: 'Europe/Berlin'
}, {
  label: 'Brussels, Copenhagen, Madrid, Paris',
  offset: 1,
  iana: 'Europe/Paris'
}, {
  label: 'West Central Africa',
  offset: 1,
  iana: 'Africa/Lagos'
}, {
  label: 'Athens, Bucharest',
  offset: 2,
  iana: 'Europe/Athens'
}, {
  label: 'Cairo',
  offset: 2,
  iana: 'Africa/Cairo'
}, {
  label: 'Harare, Pretoria',
  offset: 2,
  iana: 'Africa/Harare'
}, {
  label: 'Johannesburg',
  offset: 2,
  iana: 'Africa/Johannesburg'
}, {
  label: 'Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
  offset: 2,
  iana: 'Europe/Helsinki'
}, {
  label: 'Jerusalem',
  offset: 2,
  iana: 'Asia/Jerusalem'
}, {
  label: 'Baghdad, Kuwait, Riyadh',
  offset: 3,
  iana: 'Asia/Riyadh'
}, {
  label: 'Istanbul',
  offset: 3,
  iana: 'Europe/Istanbul'
}, {
  label: 'Moscow, St. Petersburg, Volgograd',
  offset: 3,
  iana: 'Europe/Moscow'
}, {
  label: 'Nairobi',
  offset: 3,
  iana: 'Africa/Nairobi'
}, {
  label: 'Abu Dhabi, Muscat',
  offset: 4,
  iana: 'Asia/Dubai'
}, {
  label: 'Baku, Tbilisi, Yerevan',
  offset: 4,
  iana: 'Asia/Baku'
}, {
  label: 'Islamabad, Karachi, Tashkent',
  offset: 5,
  iana: 'Asia/Karachi'
}, {
  label: 'Chennai, Kolkata, Mumbai, New Delhi',
  offset: 5,
  iana: 'Asia/Kolkata'
}, {
  label: 'Astana, Dhaka',
  offset: 6,
  iana: 'Asia/Dhaka'
}, {
  label: 'Almaty, Novosibirsk',
  offset: 6,
  iana: 'Asia/Almaty'
}, {
  label: 'Bangkok, Hanoi, Jakarta',
  offset: 7,
  iana: 'Asia/Bangkok'
}, {
  label: 'Jakarta',
  offset: 7,
  iana: 'Asia/Jakarta'
}, {
  label: 'Ho Chi Minh City',
  offset: 7,
  iana: 'Asia/Ho_Chi_Minh'
}, {
  label: 'Krasnoyarsk',
  offset: 7,
  iana: 'Asia/Krasnoyarsk'
}, {
  label: 'Beijing, Chongqing, Hong Kong, Urumqi',
  offset: 8,
  iana: 'Asia/Shanghai'
}, {
  label: 'Hong Kong',
  offset: 8,
  iana: 'Asia/Hong_Kong'
}, {
  label: 'Kuala Lumpur, Singapore',
  offset: 8,
  iana: 'Asia/Singapore'
}, {
  label: 'Kuala Lumpur',
  offset: 8,
  iana: 'Asia/Kuala_Lumpur'
}, {
  label: 'Manila',
  offset: 8,
  iana: 'Asia/Manila'
}, {
  label: 'Perth',
  offset: 8,
  iana: 'Australia/Perth'
}, {
  label: 'Taipei',
  offset: 8,
  iana: 'Asia/Taipei'
}, {
  label: 'Osaka, Sapporo, Tokyo',
  offset: 9,
  iana: 'Asia/Tokyo'
}, {
  label: 'Seoul',
  offset: 9,
  iana: 'Asia/Seoul'
}, {
  label: 'Yakutsk',
  offset: 9,
  iana: 'Asia/Yakutsk'
}, {
  label: 'Adelaide',
  offset: 9,
  iana: 'Australia/Adelaide'
}, {
  label: 'Darwin',
  offset: 9,
  iana: 'Australia/Darwin'
}, {
  label: 'Brisbane',
  offset: 10,
  iana: 'Australia/Brisbane'
}, {
  label: 'Canberra, Melbourne, Sydney',
  offset: 10,
  iana: 'Australia/Sydney'
}, {
  label: 'Guam, Port Moresby',
  offset: 10,
  iana: 'Pacific/Guam'
}, {
  label: 'Hobart',
  offset: 10,
  iana: 'Australia/Hobart'
}, {
  label: 'Vladivostok',
  offset: 10,
  iana: 'Asia/Vladivostok'
}, {
  label: 'Magadan, Solomon Is., New Caledonia',
  offset: 11,
  iana: 'Asia/Magadan'
}, {
  label: 'Auckland, Wellington',
  offset: 12,
  iana: 'Pacific/Auckland'
}, {
  label: 'Fiji, Kamchatka, Marshall Is.',
  offset: 12,
  iana: 'Pacific/Fiji'
}, {
  label: "Nuku'alofa",
  offset: 13,
  iana: 'Pacific/Tongatapu'
}];
var ALL_ISO_CODES = ['AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PN', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'UM', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'YE', 'YT', 'ZA', 'ZM', 'ZW'];
var _regionDisplay = new Intl.DisplayNames(['en'], {
  type: 'region'
});
/** Maps ISO alpha-2 country code → display country name (all ISO 3166-1 countries). */
export var COUNTRY_CODE_TO_NAME = Object.fromEntries(ALL_ISO_CODES.flatMap(function (code) {
  var name = _regionDisplay.of(code);
  return name ? [[code, name]] : [];
}));
/** Common aliases for name variations that may appear in DB location data. */
var COUNTRY_NAME_ALIASES = {
  usa: 'US',
  'united states of america': 'US',
  uk: 'GB',
  newzealand: 'NZ',
  'ivory coast': 'CI',
  'cape verde': 'CV',
  'east timor': 'TL',
  'vatican city': 'VA',
  'south korea': 'KR',
  'north korea': 'KP',
  'czech republic': 'CZ',
  turkey: 'TR',
  // ISO official names
  russia: 'RU',
  syria: 'SY',
  laos: 'LA',
  moldova: 'MD',
  tanzania: 'TZ',
  venezuela: 'VE',
  palestine: 'PS',
  micronesia: 'FM',
  // Congo variants
  'democratic republic of the congo': 'CD',
  'republic of the congo': 'CG'
};
/** Maps lowercase country name → ISO alpha-2 country code. */
var COUNTRY_NAME_TO_CODE = __assign(__assign({}, Object.fromEntries(Object.entries(COUNTRY_CODE_TO_NAME).map(function (_a) {
  var code = _a[0],
    name = _a[1];
  return [name.toLowerCase(), code];
}))), COUNTRY_NAME_ALIASES);
/** Maps (lowercase country code, lowercase province/state name) → region code. */
var STATE_PROVINCE_TO_REGION_CODE = {
  CA: {
    ontario: 'ON',
    'british columbia': 'BC',
    alberta: 'AB',
    quebec: 'QC',
    'nova scotia': 'NS',
    'new brunswick': 'NB',
    manitoba: 'MB',
    saskatchewan: 'SK',
    'prince edward island': 'PE',
    'newfoundland and labrador': 'NL',
    newfoundland: 'NL',
    'northwest territories': 'NT',
    nunavut: 'NU',
    yukon: 'YT'
  },
  ES: {
    // English names
    andalusia: 'AN',
    aragon: 'AR',
    asturias: 'AS',
    cantabria: 'CB',
    ceuta: 'CE',
    'castile and leon': 'CL',
    'castile-la mancha': 'CM',
    'canary islands': 'CN',
    catalonia: 'CT',
    extremadura: 'EX',
    galicia: 'GA',
    'balearic islands': 'IB',
    murcia: 'MC',
    madrid: 'MD',
    'community of madrid': 'MD',
    melilla: 'ML',
    navarre: 'NC',
    'basque country': 'PV',
    'la rioja': 'RI',
    'valencian community': 'VC',
    valencia: 'VC',
    // Spanish names (normalized — no accents, as returned by date-holidays or Google Places)
    andalucia: 'AN',
    'castilla y leon': 'CL',
    'islas canarias': 'CN',
    cataluna: 'CT',
    'illes balears': 'IB',
    'islas baleares': 'IB',
    'murcia region': 'MC',
    'comunidad de madrid': 'MD',
    'ciudad de ceuta': 'CE',
    'ciudad de melilla': 'ML',
    'comunidad foral de navarra': 'NC',
    navarra: 'NC',
    'pais vasco': 'PV',
    'comunitat valenciana': 'VC',
    // Catalan / regional language names (as Google Places may return)
    catalunya: 'CT',
    euskadi: 'PV'
  },
  US: {
    alabama: 'AL',
    alaska: 'AK',
    arizona: 'AZ',
    arkansas: 'AR',
    california: 'CA',
    colorado: 'CO',
    connecticut: 'CT',
    delaware: 'DE',
    florida: 'FL',
    georgia: 'GA',
    hawaii: 'HI',
    idaho: 'ID',
    illinois: 'IL',
    indiana: 'IN',
    iowa: 'IA',
    kansas: 'KS',
    kentucky: 'KY',
    louisiana: 'LA',
    maine: 'ME',
    maryland: 'MD',
    massachusetts: 'MA',
    michigan: 'MI',
    minnesota: 'MN',
    mississippi: 'MS',
    missouri: 'MO',
    montana: 'MT',
    nebraska: 'NE',
    nevada: 'NV',
    'new hampshire': 'NH',
    'new jersey': 'NJ',
    'new mexico': 'NM',
    'new york': 'NY',
    'north carolina': 'NC',
    'north dakota': 'ND',
    ohio: 'OH',
    oklahoma: 'OK',
    oregon: 'OR',
    pennsylvania: 'PA',
    'rhode island': 'RI',
    'south carolina': 'SC',
    'south dakota': 'SD',
    tennessee: 'TN',
    texas: 'TX',
    utah: 'UT',
    vermont: 'VT',
    virginia: 'VA',
    washington: 'WA',
    'west virginia': 'WV',
    wisconsin: 'WI',
    wyoming: 'WY',
    'district of columbia': 'DC'
  }
};
/** Returns { countryCode, regionCode } inferred from location data, or undefined. */
export function inferLocationRegion(countryName, stateProvince) {
  var _a, _b;
  var countryCode = COUNTRY_NAME_TO_CODE[countryName.toLowerCase().trim()];
  if (!countryCode) return null;
  var regionMap = STATE_PROVINCE_TO_REGION_CODE[countryCode];
  var sp = (_a = stateProvince === null || stateProvince === void 0 ? void 0 : stateProvince.trim()) !== null && _a !== void 0 ? _a : null;
  var directCode = sp && regionMap && Object.values(regionMap).includes(sp.toUpperCase()) ? sp.toUpperCase() : null;
  var regionCode = sp && regionMap ? (_b = regionMap[sp.toLowerCase()]) !== null && _b !== void 0 ? _b : directCode : null;
  return {
    countryCode: countryCode,
    regionCode: regionCode
  };
}
/** Province/state → { label, iana } maps */
var CA_PROVINCE_TIMEZONE = {
  BC: {
    label: 'Pacific Time — US & Canada',
    iana: 'America/Vancouver'
  },
  YT: {
    label: 'Pacific Time — US & Canada',
    iana: 'America/Whitehorse'
  },
  AB: {
    label: 'Mountain Time — US & Canada',
    iana: 'America/Edmonton'
  },
  NT: {
    label: 'Mountain Time — US & Canada',
    iana: 'America/Yellowknife'
  },
  SK: {
    label: 'Central Time — US & Canada',
    iana: 'America/Regina'
  },
  MB: {
    label: 'Central Time — US & Canada',
    iana: 'America/Winnipeg'
  },
  NU: {
    label: 'Central Time — US & Canada',
    iana: 'America/Rankin_Inlet'
  },
  ON: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/Toronto'
  },
  QC: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/Toronto'
  },
  NS: {
    label: 'Atlantic Time — Canada',
    iana: 'America/Halifax'
  },
  NB: {
    label: 'Atlantic Time — Canada',
    iana: 'America/Moncton'
  },
  PE: {
    label: 'Atlantic Time — Canada',
    iana: 'America/Halifax'
  },
  NL: {
    label: 'Atlantic Time — Canada',
    iana: 'America/St_Johns'
  }
};
var US_STATE_TIMEZONE = {
  AL: {
    label: 'Central Time — US & Canada',
    iana: 'America/Chicago'
  },
  AK: {
    label: 'Alaska',
    iana: 'America/Anchorage'
  },
  AZ: {
    label: 'Arizona',
    iana: 'America/Phoenix'
  },
  AR: {
    label: 'Central Time — US & Canada',
    iana: 'America/Chicago'
  },
  CA: {
    label: 'Pacific Time — US & Canada',
    iana: 'America/Los_Angeles'
  },
  CO: {
    label: 'Mountain Time — US & Canada',
    iana: 'America/Denver'
  },
  CT: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  DE: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  FL: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  GA: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  HI: {
    label: 'Hawaii',
    iana: 'Pacific/Honolulu'
  },
  ID: {
    label: 'Mountain Time — US & Canada',
    iana: 'America/Denver'
  },
  IL: {
    label: 'Central Time — US & Canada',
    iana: 'America/Chicago'
  },
  IN: {
    label: 'Indiana (East)',
    iana: 'America/Indiana/Indianapolis'
  },
  IA: {
    label: 'Central Time — US & Canada',
    iana: 'America/Chicago'
  },
  KS: {
    label: 'Central Time — US & Canada',
    iana: 'America/Chicago'
  },
  KY: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  LA: {
    label: 'Central Time — US & Canada',
    iana: 'America/Chicago'
  },
  ME: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  MD: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  MA: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  MI: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  MN: {
    label: 'Central Time — US & Canada',
    iana: 'America/Chicago'
  },
  MS: {
    label: 'Central Time — US & Canada',
    iana: 'America/Chicago'
  },
  MO: {
    label: 'Central Time — US & Canada',
    iana: 'America/Chicago'
  },
  MT: {
    label: 'Mountain Time — US & Canada',
    iana: 'America/Denver'
  },
  NE: {
    label: 'Central Time — US & Canada',
    iana: 'America/Chicago'
  },
  NV: {
    label: 'Pacific Time — US & Canada',
    iana: 'America/Los_Angeles'
  },
  NH: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  NJ: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  NM: {
    label: 'Mountain Time — US & Canada',
    iana: 'America/Denver'
  },
  NY: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  NC: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  ND: {
    label: 'Central Time — US & Canada',
    iana: 'America/Chicago'
  },
  OH: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  OK: {
    label: 'Central Time — US & Canada',
    iana: 'America/Chicago'
  },
  OR: {
    label: 'Pacific Time — US & Canada',
    iana: 'America/Los_Angeles'
  },
  PA: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  RI: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  SC: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  SD: {
    label: 'Central Time — US & Canada',
    iana: 'America/Chicago'
  },
  TN: {
    label: 'Central Time — US & Canada',
    iana: 'America/Chicago'
  },
  TX: {
    label: 'Central Time — US & Canada',
    iana: 'America/Chicago'
  },
  UT: {
    label: 'Mountain Time — US & Canada',
    iana: 'America/Denver'
  },
  VT: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  VA: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  WA: {
    label: 'Pacific Time — US & Canada',
    iana: 'America/Los_Angeles'
  },
  WV: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  },
  WI: {
    label: 'Central Time — US & Canada',
    iana: 'America/Chicago'
  },
  WY: {
    label: 'Mountain Time — US & Canada',
    iana: 'America/Denver'
  },
  DC: {
    label: 'Eastern Time — US & Canada',
    iana: 'America/New_York'
  }
};
var PROVINCE_TIMEZONE = {
  CA: CA_PROVINCE_TIMEZONE,
  US: US_STATE_TIMEZONE
};
/** Country-level fallback when no province is known. */
var COUNTRY_TIMEZONE_LABEL = {
  CA: 'Eastern Time — US & Canada',
  US: 'Eastern Time — US & Canada',
  GB: 'Dublin, Edinburgh, Lisbon, London',
  IE: 'Dublin, Edinburgh, Lisbon, London',
  AU: 'Canberra, Melbourne, Sydney',
  NZ: 'Auckland, Wellington',
  DE: 'Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
  FR: 'Brussels, Copenhagen, Madrid, Paris',
  IN: 'Chennai, Kolkata, Mumbai, New Delhi',
  MX: 'Mexico City',
  BR: 'Brasilia',
  SG: 'Kuala Lumpur, Singapore',
  PH: 'Kuala Lumpur, Singapore'
};
/** Primary IANA timezone per country (capital / most-populated zone).
 *  Used as fallback when the location has the generic 'UTC' migration default
 *  and no province-level match exists. The Google TimeZone API provides
 *  the precise zone for newly created locations with lat/lng. */
var COUNTRY_IANA_TIMEZONE = {
  AD: 'Europe/Andorra',
  AE: 'Asia/Dubai',
  AF: 'Asia/Kabul',
  AG: 'America/Antigua',
  AI: 'America/Anguilla',
  AL: 'Europe/Tirane',
  AM: 'Asia/Yerevan',
  AO: 'Africa/Luanda',
  AR: 'America/Argentina/Buenos_Aires',
  AS: 'Pacific/Pago_Pago',
  AT: 'Europe/Vienna',
  AU: 'Australia/Sydney',
  AW: 'America/Aruba',
  AX: 'Europe/Helsinki',
  AZ: 'Asia/Baku',
  BA: 'Europe/Sarajevo',
  BB: 'America/Barbados',
  BD: 'Asia/Dhaka',
  BE: 'Europe/Brussels',
  BF: 'Africa/Ouagadougou',
  BG: 'Europe/Sofia',
  BH: 'Asia/Bahrain',
  BI: 'Africa/Bujumbura',
  BJ: 'Africa/Porto-Novo',
  BL: 'America/St_Barthelemy',
  BM: 'Atlantic/Bermuda',
  BN: 'Asia/Brunei',
  BO: 'America/La_Paz',
  BQ: 'America/Kralendijk',
  BR: 'America/Sao_Paulo',
  BS: 'America/Nassau',
  BT: 'Asia/Thimphu',
  BW: 'Africa/Gaborone',
  BY: 'Europe/Minsk',
  BZ: 'America/Belize',
  CA: 'America/Toronto',
  CC: 'Indian/Cocos',
  CD: 'Africa/Kinshasa',
  CF: 'Africa/Bangui',
  CG: 'Africa/Brazzaville',
  CH: 'Europe/Zurich',
  CI: 'Africa/Abidjan',
  CK: 'Pacific/Rarotonga',
  CL: 'America/Santiago',
  CM: 'Africa/Douala',
  CN: 'Asia/Shanghai',
  CO: 'America/Bogota',
  CR: 'America/Costa_Rica',
  CU: 'America/Havana',
  CV: 'Atlantic/Cape_Verde',
  CW: 'America/Curacao',
  CX: 'Indian/Christmas',
  CY: 'Asia/Nicosia',
  CZ: 'Europe/Prague',
  DE: 'Europe/Berlin',
  DJ: 'Africa/Djibouti',
  DK: 'Europe/Copenhagen',
  DM: 'America/Dominica',
  DO: 'America/Santo_Domingo',
  DZ: 'Africa/Algiers',
  EC: 'America/Guayaquil',
  EE: 'Europe/Tallinn',
  EG: 'Africa/Cairo',
  EH: 'Africa/El_Aaiun',
  ER: 'Africa/Asmara',
  ES: 'Europe/Madrid',
  ET: 'Africa/Addis_Ababa',
  FI: 'Europe/Helsinki',
  FJ: 'Pacific/Fiji',
  FK: 'Atlantic/Stanley',
  FM: 'Pacific/Pohnpei',
  FO: 'Atlantic/Faroe',
  FR: 'Europe/Paris',
  GA: 'Africa/Libreville',
  GB: 'Europe/London',
  GD: 'America/Grenada',
  GE: 'Asia/Tbilisi',
  GF: 'America/Cayenne',
  GG: 'Europe/Guernsey',
  GH: 'Africa/Accra',
  GI: 'Europe/Gibraltar',
  GL: 'America/Nuuk',
  GM: 'Africa/Banjul',
  GN: 'Africa/Conakry',
  GP: 'America/Guadeloupe',
  GQ: 'Africa/Malabo',
  GR: 'Europe/Athens',
  GT: 'America/Guatemala',
  GU: 'Pacific/Guam',
  GW: 'Africa/Bissau',
  GY: 'America/Guyana',
  HK: 'Asia/Hong_Kong',
  HN: 'America/Tegucigalpa',
  HR: 'Europe/Zagreb',
  HT: 'America/Port-au-Prince',
  HU: 'Europe/Budapest',
  ID: 'Asia/Jakarta',
  IE: 'Europe/Dublin',
  IL: 'Asia/Jerusalem',
  IM: 'Europe/Isle_of_Man',
  IN: 'Asia/Kolkata',
  IO: 'Indian/Chagos',
  IQ: 'Asia/Baghdad',
  IR: 'Asia/Tehran',
  IS: 'Atlantic/Reykjavik',
  IT: 'Europe/Rome',
  JE: 'Europe/Jersey',
  JM: 'America/Jamaica',
  JO: 'Asia/Amman',
  JP: 'Asia/Tokyo',
  KE: 'Africa/Nairobi',
  KG: 'Asia/Bishkek',
  KH: 'Asia/Phnom_Penh',
  KI: 'Pacific/Tarawa',
  KM: 'Indian/Comoro',
  KN: 'America/St_Kitts',
  KP: 'Asia/Pyongyang',
  KR: 'Asia/Seoul',
  KW: 'Asia/Kuwait',
  KY: 'America/Cayman',
  KZ: 'Asia/Almaty',
  LA: 'Asia/Vientiane',
  LB: 'Asia/Beirut',
  LC: 'America/St_Lucia',
  LI: 'Europe/Vaduz',
  LK: 'Asia/Colombo',
  LR: 'Africa/Monrovia',
  LS: 'Africa/Maseru',
  LT: 'Europe/Vilnius',
  LU: 'Europe/Luxembourg',
  LV: 'Europe/Riga',
  LY: 'Africa/Tripoli',
  MA: 'Africa/Casablanca',
  MC: 'Europe/Monaco',
  MD: 'Europe/Chisinau',
  ME: 'Europe/Podgorica',
  MF: 'America/Marigot',
  MG: 'Indian/Antananarivo',
  MH: 'Pacific/Majuro',
  MK: 'Europe/Skopje',
  ML: 'Africa/Bamako',
  MM: 'Asia/Yangon',
  MN: 'Asia/Ulaanbaatar',
  MO: 'Asia/Macau',
  MP: 'Pacific/Saipan',
  MQ: 'America/Martinique',
  MR: 'Africa/Nouakchott',
  MS: 'America/Montserrat',
  MT: 'Europe/Malta',
  MU: 'Indian/Mauritius',
  MV: 'Indian/Maldives',
  MW: 'Africa/Blantyre',
  MX: 'America/Mexico_City',
  MY: 'Asia/Kuala_Lumpur',
  MZ: 'Africa/Maputo',
  NA: 'Africa/Windhoek',
  NC: 'Pacific/Noumea',
  NE: 'Africa/Niamey',
  NF: 'Pacific/Norfolk',
  NG: 'Africa/Lagos',
  NI: 'America/Managua',
  NL: 'Europe/Amsterdam',
  NO: 'Europe/Oslo',
  NP: 'Asia/Kathmandu',
  NR: 'Pacific/Nauru',
  NU: 'Pacific/Niue',
  NZ: 'Pacific/Auckland',
  OM: 'Asia/Muscat',
  PA: 'America/Panama',
  PE: 'America/Lima',
  PF: 'Pacific/Tahiti',
  PG: 'Pacific/Port_Moresby',
  PH: 'Asia/Manila',
  PK: 'Asia/Karachi',
  PL: 'Europe/Warsaw',
  PM: 'America/Miquelon',
  PN: 'Pacific/Pitcairn',
  PR: 'America/Puerto_Rico',
  PS: 'Asia/Hebron',
  PT: 'Europe/Lisbon',
  PW: 'Pacific/Palau',
  PY: 'America/Asuncion',
  QA: 'Asia/Qatar',
  RE: 'Indian/Reunion',
  RO: 'Europe/Bucharest',
  RS: 'Europe/Belgrade',
  RU: 'Europe/Moscow',
  RW: 'Africa/Kigali',
  SA: 'Asia/Riyadh',
  SB: 'Pacific/Guadalcanal',
  SC: 'Indian/Mahe',
  SD: 'Africa/Khartoum',
  SE: 'Europe/Stockholm',
  SG: 'Asia/Singapore',
  SH: 'Atlantic/St_Helena',
  SI: 'Europe/Ljubljana',
  SJ: 'Arctic/Longyearbyen',
  SK: 'Europe/Bratislava',
  SL: 'Africa/Freetown',
  SM: 'Europe/San_Marino',
  SN: 'Africa/Dakar',
  SO: 'Africa/Mogadishu',
  SR: 'America/Paramaribo',
  SS: 'Africa/Juba',
  ST: 'Africa/Sao_Tome',
  SV: 'America/El_Salvador',
  SX: 'America/Lower_Princes',
  SY: 'Asia/Damascus',
  SZ: 'Africa/Mbabane',
  TC: 'America/Grand_Turk',
  TD: 'Africa/Ndjamena',
  TF: 'Indian/Kerguelen',
  TG: 'Africa/Lome',
  TH: 'Asia/Bangkok',
  TJ: 'Asia/Dushanbe',
  TK: 'Pacific/Fakaofo',
  TL: 'Asia/Dili',
  TM: 'Asia/Ashgabat',
  TN: 'Africa/Tunis',
  TO: 'Pacific/Tongatapu',
  TR: 'Europe/Istanbul',
  TT: 'America/Port_of_Spain',
  TV: 'Pacific/Funafuti',
  TW: 'Asia/Taipei',
  TZ: 'Africa/Dar_es_Salaam',
  UA: 'Europe/Kyiv',
  UG: 'Africa/Kampala',
  UM: 'Pacific/Midway',
  US: 'America/New_York',
  UY: 'America/Montevideo',
  UZ: 'Asia/Tashkent',
  VA: 'Europe/Vatican',
  VC: 'America/St_Vincent',
  VE: 'America/Caracas',
  VG: 'America/Tortola',
  VI: 'America/St_Thomas',
  VN: 'Asia/Ho_Chi_Minh',
  VU: 'Pacific/Efate',
  WF: 'Pacific/Wallis',
  WS: 'Pacific/Apia',
  YE: 'Asia/Aden',
  YT: 'Indian/Mayotte',
  ZA: 'Africa/Johannesburg',
  ZM: 'Africa/Lusaka',
  ZW: 'Africa/Harare'
};
var DEFAULT_TIMEZONE = 'Etc/UTC';
export function inferTimezoneLabel(countryName, stateProvince) {
  var _a, _b, _c;
  var region = inferLocationRegion(countryName, stateProvince);
  if (!region) return DEFAULT_TIMEZONE;
  var countryCode = region.countryCode,
    regionCode = region.regionCode;
  if (regionCode) {
    var label = (_b = (_a = PROVINCE_TIMEZONE[countryCode]) === null || _a === void 0 ? void 0 : _a[regionCode]) === null || _b === void 0 ? void 0 : _b.label;
    if (label) return label;
  }
  return (_c = COUNTRY_TIMEZONE_LABEL[countryCode]) !== null && _c !== void 0 ? _c : DEFAULT_TIMEZONE;
}
/** Returns the best-matching IANA timezone ID for a location, or null if unknown.
 *  countryCode — pass the ISO 3166-1 alpha-2 code directly to bypass the country-name lookup,
 *  which fails when Google Places returns a non-English country name (e.g. "Viet Nam" in French locale). */
export function inferTimezoneIana(countryName, stateProvince, countryCode) {
  var _a, _b, _c, _d;
  var region = inferLocationRegion(countryName !== null && countryName !== void 0 ? countryName : '', stateProvince !== null && stateProvince !== void 0 ? stateProvince : null);
  var resolvedCountryCode = (_a = countryCode === null || countryCode === void 0 ? void 0 : countryCode.toUpperCase()) !== null && _a !== void 0 ? _a : region === null || region === void 0 ? void 0 : region.countryCode;
  if (!resolvedCountryCode) return DEFAULT_TIMEZONE;
  var regionCode = region === null || region === void 0 ? void 0 : region.regionCode;
  if (regionCode) {
    var iana = (_c = (_b = PROVINCE_TIMEZONE[resolvedCountryCode]) === null || _b === void 0 ? void 0 : _b[regionCode]) === null || _c === void 0 ? void 0 : _c.iana;
    if (iana) return iana;
  }
  return (_d = COUNTRY_IANA_TIMEZONE[resolvedCountryCode]) !== null && _d !== void 0 ? _d : DEFAULT_TIMEZONE;
}
export function buildRegionLabel(countryCode, regionCode, regionList, locale) {
  var _a, _b, _c, _d;
  var displayNames = new Intl.DisplayNames([locale !== null && locale !== void 0 ? locale : 'en'], {
    type: 'region'
  });
  var countryName = (_b = (_a = displayNames.of(countryCode)) !== null && _a !== void 0 ? _a : COUNTRY_CODE_TO_NAME[countryCode]) !== null && _b !== void 0 ? _b : countryCode;
  if (!regionCode) return countryName;
  var fallbackName = (_d = (_c = regionList.find(function (r) {
    return r.code === regionCode;
  })) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : regionCode;
  var regionName = fallbackName;
  try {
    var localized = displayNames.of("".concat(countryCode, "-").concat(regionCode));
    if (localized) regionName = localized;
  } catch (_e) {
    // subdivision codes not supported in this environment, keep fallback
  }
  return "".concat(regionName, ": ").concat(countryName);
}
/** Generates time options in 15-minute increments in 12-hour display format.
 *  Values stored as 24-hour HH:MM:SS strings. */
export var TIME_CLOSED = 'CLOSED';
export var TIME_24H = '24H';
/** Stored 24-hour time for midnight; used as both endpoints of a 24H (all-day) range. */
export var TIME_MIDNIGHT = '00:00:00';
export var TIME_OPTIONS = function () {
  var options = [];
  for (var h = 0; h < 24; h++) {
    for (var m = 0; m < 60; m += 15) {
      var hh = String(h).padStart(2, '0');
      var mm = String(m).padStart(2, '0');
      var value = "".concat(hh, ":").concat(mm, ":00");
      var period = h < 12 ? 'AM' : 'PM';
      var hour12 = void 0;
      if (h === 0) hour12 = 12;else if (h > 12) hour12 = h - 12;else hour12 = h;
      var label = "".concat(String(hour12).padStart(2, '0'), ":").concat(mm, " ").concat(period);
      options.push({
        label: label,
        value: value
      });
    }
  }
  return options;
}();